import $ from 'jquery';

$(function () {

    function askForConfirm(event) {

        const $element = $(this);

        if (!confirm($element.data('alert'))) {
            event.preventDefault();
        }
    }

    $('body')
        .on('click', 'a.confirmed, button.confirmed', askForConfirm)
        .on('submit', 'form.confirmed', askForConfirm);

    $('form').on('submit', function (e) {

        var $form = $(this);

        if ($form.data('submitted')) {

            e.preventDefault();
        }

        setTimeout(function () {
            $form.find('button[type=submit]').each(function () {
                const $btn = $(this);

                if (!$btn.data('no-auto-disable')) {
                    $btn.prop('disabled', 'disabled');
                }
            });
        }, 0);
    });

});
